import { render, staticRenderFns } from "./FileCardEn.vue?vue&type=template&id=b17405ca&"
import script from "./FileCardEn.vue?vue&type=script&lang=js&"
export * from "./FileCardEn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports